import { Button, ButtonGroup } from '@chakra-ui/react';
import { useLanguage } from '../i18n/LanguageContext';

const LanguageToggle = () => {
  const { language, setLanguage, t } = useLanguage();

  return (
    <ButtonGroup
      isAttached
      size="sm"
      variant="outline"
      ml={{ base: 2, lg: 4 }}
      aria-label={t('common.languageSelection')}
    >
      <Button
        onClick={() => setLanguage('zh')}
        aria-label={t('language.switchToChinese')}
        aria-pressed={language === 'zh'}
        bg={language === 'zh' ? 'white' : 'transparent'}
        color={language === 'zh' ? '#2f4f4f' : 'white'}
        borderColor="whiteAlpha.700"
        _hover={{ bg: 'whiteAlpha.300' }}
      >
        {t('language.chinese')}
      </Button>
      <Button
        onClick={() => setLanguage('en')}
        aria-label={t('language.switchToEnglish')}
        aria-pressed={language === 'en'}
        bg={language === 'en' ? 'white' : 'transparent'}
        color={language === 'en' ? '#2f4f4f' : 'white'}
        borderColor="whiteAlpha.700"
        _hover={{ bg: 'whiteAlpha.300' }}
      >
        {t('language.english')}
      </Button>
    </ButtonGroup>
  );
};

export default LanguageToggle;
